<div class="w-full h-full flex justify-content-center align-items-center">
  <p>{{ "timeout.message" | translate }}</p>
</div>
